<template>
  <Layout :kind="layout">
    <template #header>
      <TheNavbar :spaced="!['browser'].includes(layout)"></TheNavbar>
    </template>
    <template #subheader>
      <TheBreadcrumb :key="$route.path"></TheBreadcrumb>
    </template>
    <template #default>
      <router-view id="app" />
    </template>
    <template #footer>
      <TheFooter></TheFooter>
      <TheCookieConsent />
    </template>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout.vue";
import TheNavbar from "@/components/TheNavbar.vue";
import TheBreadcrumb from "@/components/TheBreadcrumb.vue";
import TheFooter from "@/components/TheFooter.vue";
import TheCookieConsent from "@/components/TheCookieConsent.vue";

export default {
  components: {
    Layout,
    TheNavbar,
    TheBreadcrumb,
    TheFooter,
    TheCookieConsent,
  },
  head: {
    title() {
      const meta = this.$route.meta;
      if (!meta || !meta.title) return null;
      return {
        inner: meta.title,
      };
    },
  },
  watch: {
    $route: {
      handler(value) {
        // tell vue-head to update
        this.$emit("updateHead");
      },
      immediate: true,
    },
  },
  computed: {
    layout() {
      try {
        return this.$route.meta.layout;
      } catch (err) {
        return "default";
      }
    },
  },
};
</script>

<style lang="scss">
html,
body,
#app {
  height: 100%;
}

.is-margin-top {
  margin-top: 1.5rem;
}

.is-margin-bottom {
  margin-bottom: 1.25rem;
}
.icon {
  max-width: 12px !important;
  display: grid !important;
}
.svg-inline--fa {
  max-width: 12px !important;
  display: grid !important;
}

@import "~bulma/sass/utilities/_all";
@import "assets/custom.scss";

@import "bulma";
@import "buefy/src/scss/buefy";
</style>
